/** @jsx isolateComponent */

import { Fragment } from 'react';
import { BrandButton } from '@zapier/design-system';
import { emitUserInteractionEvent } from '../../utils/avroEvents';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { loginPath, signupPath } from '../../constants';
import { useUniversalNavContext } from '../../../universal-nav/hooks';

import UniversalTopbarLink from './UniversalTopbarLink';

type Props = {
  /**
   * `Href` to login button.
   */
  loginHref: string;
  /**
   * Currently navigated to url.
   */
  selectedHref: string;
  /**
   * Indicates whether Log in button should render.
   */
  shouldRenderSignIn: boolean;
  /**
   * Indicates whether Sign up button should render.
   */
  shouldRenderSignUp: boolean;
  /**
   * The size of the component, which influences the size of its buttons.
   */
  size: 'small' | 'medium';
  /**
   * `Href` to signup button.
   */
  signupHref: string;
};

const Styles = labelStyles('AccountActions', {
  signupButton: {
    minWidth: 100,
  },
});

/**
 * @private
 * Conditionally renders a login link and sign up button.
 */
export const AccountActions = (props: Props) => {
  const { getFullyQualifiedURL } = useUniversalNavContext();

  const signupPreintentEvent = () => {
    emitUserInteractionEvent({
      interaction_name: 'universalnav-signup',
      event_action: 'click',
      option_selected: 'Sign up',
    });
  };
  return (
    <Fragment>
      {props.shouldRenderSignIn && (
        <UniversalTopbarLink
          href={getFullyQualifiedURL(props.loginHref) || null}
          isSelected={props.selectedHref.includes(props.loginHref)}
        >
          Log in
        </UniversalTopbarLink>
      )}
      {props.shouldRenderSignUp && (
        <div css={Styles.signupButton}>
          <BrandButton
            href={props.signupHref}
            id="universalnav-signup"
            isFullWidth={true}
            onClick={signupPreintentEvent}
          >
            Sign up
          </BrandButton>
        </div>
      )}
    </Fragment>
  );
};

AccountActions.defaultProps = {
  loginHref: loginPath,
  selectedHref: '',
  signupHref: signupPath,
  size: 'medium',
};

export default AccountActions;
